/**
 * Las pestañas bajo los indicadores. Se identifican por nombre y no por posición: «Evoluciones médicas» solo existe con el
 * permiso, así que las posiciones cambian de un perfil a otro.
 */
export type HospitalizationTab = 'evolution' | 'grouped' | 'list' | 'census' | 'evolutions'

/** En el orden en que se ofrecen. */
export const HOSPITALIZATION_TABS: readonly HospitalizationTab[] = ['evolution', 'grouped', 'list', 'census', 'evolutions']

export const HOSPITALIZATION_TAB_LABEL_ID: Record<HospitalizationTab, string> = {
  evolution: 'HospitalizationSummaryTabEvolution',
  grouped: 'HospitalizationSummaryTabGrouped',
  list: 'HospitalizationSummaryTabList',
  census: 'HospitalizationSummaryTabCensus',
  evolutions: 'HospitalizationSummaryTabEvolutions',
}

/** La grilla de cada pestaña que lo es (para exportar lo último que pidió su tabla). */
export const HOSPITALIZATION_TAB_GRID = { list: 'list', census: 'census', evolutions: 'evolutions' } as const
